import { useCallback } from "react";

import { utils } from "@atlaskit/util-service-support";

interface ToggleReadStateOptions {
    notificationLogUrl: string;
    notificationId: string;
    isCurrentlyRead: boolean;
}

export const useToggleNotificationReadState = () => {
    const toggleReadState = useCallback(
        async ({
            notificationLogUrl,
            notificationId,
            isCurrentlyRead
        }: ToggleReadStateOptions) => {
            const newState = isCurrentlyRead ? "UNREAD" : "READ";

            try {
                await utils.requestService<{ success: boolean }>(
                    {
                        url: `${notificationLogUrl}/api/3/notifications/mark/bulk`
                    },
                    {
                        requestInit: {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "content-type": "application/json",
                                "Accept-Language": "en",
                                "x-app-name": "wac-notifications",
                                "x-app-version": "local"
                            },
                            body: JSON.stringify({
                                toState: newState,
                                ids: [notificationId]
                            })
                        }
                    }
                );

                return true;
            } catch (err) {
                console.error("Failed to toggle notification read state:", err);
                return false;
            }
        },
        []
    );

    return { toggleReadState };
};
